import React from "react";
import { Card, Button, Container, Row, Col } from "react-bootstrap";

const VideoCard = ({ title, videoId, description }) => {
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <Card style={{ marginBottom: "20px" }}>
      <Card.Img
        variant="top"
        src={`https://img.youtube.com/vi/${videoId}/0.jpg`}
      />
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text>{description}</Card.Text>
        <Button style={{backgroundColor:"#151B54", borderColor:"transparent"}} href={embedUrl} target="_blank">
          Watch Video
        </Button>
      </Card.Body>
    </Card>
  );
};

const VideoSection = ({ title, videos }) => (
  <Container>
    <h2 className="my-4 text-center" style={{ color: "#483285" }}>
      {title}
    </h2>
    <Row>
      {videos.map((video, index) => (
        <Col key={index} sm={12} md={6} lg={4}>
          <VideoCard
            title={video.title}
            videoId={video.videoId}
            description={video.description}
          />
        </Col>
      ))}
    </Row>
  </Container>
);

const App = () => {
  const laserTechVideos = [
    {
      title: "dr.shno baba rasul",
      videoId: "svaNaW484nM",
      description: "Installation of the Epilyum laser hair removal device at Dr. Shno Baba Rasul clinic.",
    },
    {
      title: "Dr. Fenk Jabar",
      videoId: "yLj95m7_wGU",
      description: "Installation of the Epilyum laser hair removal device at Dr. Fenk Jabar’s clinic.",
    },
    {
      title: "Dr. Snoor Aqrawi",
      videoId: "9suoiCOyPVs",
      description: "Installation of the Epilyum laser hair removal device at Dr. Snoor Aqrawi’s clinic.",
    },
     {
      title: "Medico 2025",
      videoId: "9MAMrzTdMv8",
      description: "Medico 2025 has been an incredible journey, We’re beyond thrilled to have wrapped up this exhibition with great success, joining us over 1,000 visitors",
    },
  {
  title: "Epilyum Academy Duhok",
  videoId: "ZuMhD_5GBUo", // Replace with actual video ID
  description: "Epilyum Academy in Duhok provides comprehensive CO2 laser training for dermatologists alongside certification on the full Epilyum device ecosystem including AI REVEAL, ThermiLif HIFU, and PICO technologies.",
},
{
  title: "Epilyum Academy Sulaymaniyah",
  videoId: "cKk7zTdZxgA",
  description: "Epilyum Academy 2025 in Sulaymaniyah featured a professional presentation on CO₂ Laser technology, highlighting the AXISONE CO2 system, along with a live showcase of the latest Epilyum devices for dermatologists and medical professionals.",
},
{
  title: "Epilyum Academy Erbil",
  videoId: "n2rc4BhWHZM", // Replace with actual video ID
  description: "Epilyum Academy Erbil featured in-depth presentations on IPL Revive technology and the AXISONE CO2 laser system, showcasing advanced treatments for skin rejuvenation, scar revision, and various dermatological conditions for medical professionals.",
},
    
    {
      title: "Rafidain Plastic Surgery 2025",
      videoId: "ZTYtQjFAzyA",
      description: "We’re excited to be participating in the Rafidain Plastic Surgery event! Here’s a quick look at highlights from Day 1 — stay tuned for more moments from the exhibition!",
    },
  ];

  const doctorTalksVideos = [
    {
      title: "Dr. Roshan Dara",
      videoId: "zZ-_8zeumnU",
      description: "Dr. Roshan Dara talks about the Epilyum laser device, sharing insights on its features, effectiveness, and clinical benefits.",
    },
  {
      title: "Dr.Barzan Al-Mirany",
      videoId: "l7z95hTNoZ8",
      description: "Dr. Barzan Al-Mirany discusses the Epilyum IPL Revive's advanced technology for safe, effective treatments with minimal discomfort.",
    },
  {
  title: "Dr. Laween Dizayee",
  videoId: "r1AlTyKruKQ",
  description: "Dermatology specialist Dr. Laween Dizayee discusses advanced IPL technology for treating various skin concerns in this professional podcast.",
},
{
  title: "Dr. Zana M. Abbas",
  videoId: "NoBUYXFRlbU",
  description: "Dermatology specialist Dr. Zana M. Abbas discusses the advanced technologies available in his clinic, including the EPILYUM AI REVEAL Skin Analyzer with 8-spectrum imaging for 17+ skin concerns, and the ThermiLif HIFU system for exceptional skin lifting and shaping results.",
},
{
  title: "Dr. Kurda Faraidoon",
  videoId: "yn9pC9OJMoE",
  description: "Dermatology specialist Dr. Kurda Faraidoon discusses the EPILYUM AI REVEAL Skin Analyzer available in her clinic, an advanced device using 8-spectrum imaging and AI algorithms to analyze over 17 facial skin concerns with high-resolution 3D mapping.",
}
  ];

  return (
    <>
      <VideoSection
        title="Installations, Workshops, and Conferences of Epilyum"
        videos={laserTechVideos}
      />
      <VideoSection
        title="Doctors Talk About Epilyum Devices"
        videos={doctorTalksVideos}
      />
    </>
  );
};

export default App;
